import React from 'react';
// models
import { IPoll } from 'models/Poll';
// Mui
import { makeStyles } from '@mui/styles';
import { Card, Typography, Tooltip, Grid, Button } from '@mui/material';

type Props = {
  poll: IPoll;
  openDetailsDialog: (poll: IPoll) => void;
}

const PollCard: React.FC<Props> = ({ poll, openDetailsDialog }) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Card sx={{ p: 2, borderRadius: 0, borderBottom: '1px solid #eee' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={10}>
            <Typography className={classes.title}>
              Question
            </Typography>
            <Tooltip title={poll.question}>
              <Typography className={classes.text} sx={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                {poll.question}
              </Typography>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={() => openDetailsDialog(poll)}>{poll.voted ? 'Details' : 'Vote'}</Button>
          </Grid>
        </Grid>
      </Card>
    </React.Fragment>
  );
};

export default React.memo(PollCard);

const useStyles = makeStyles({
  title: {
    fontSize: '12px',
    lineHeight: '166%',
    letterSpacing: '0.4px',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  text: {
    fontSize: '14px',
    lineHeight: '143%',
    letterSpacing: '0.17px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  }
});